export default "__VITE_PUBLIC_ASSET__844eed9f__"